import React, { memo, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ValueDriverContent from '@modules/insights/valueDriverManager/content';
import actions from '@flux/action';
import { produce } from 'immer';
import { formatValueDriverManageListData } from '@flux/action/insights';
import { Loading } from '@components';

function ValueDriver({ history, instanceId, cRef, formChange }) {
  const dispatch = useDispatch();
  const [formExpand, setFormExpand] = useState(false);
  const { data, isFetching } = useSelector(
    ({ systemSettings: { valuedriverData, fetchingValueDriverTmplt } }) => ({
      data: valuedriverData,
      isFetching: fetchingValueDriverTmplt,
    }),
  );

  const afterSave = () => {
    history.replace('/settings');
    // clean data of value drivers
    dispatch(
      actions.changeValueDriver({
        valueDriverItems: [],
      }),
    );
  };

  useEffect(() => {
    dispatch(
      actions.changeValueDriver({
        valueDriverItems: [],
      }),
    );
    if (!instanceId) {
      return;
    }
    dispatch(actions.fetchValuedricerTemplate(instanceId));

    return () => {
      dispatch(actions.initialValuedriverData());
    };
  }, [instanceId]);

  const dataFormated = useMemo(() => {
    const d = produce(data, (draft) => {
      const items = draft.valueDriverItems;
      for (const i in items) {
        formatValueDriverManageListData(items[i], draft.format);
      }
      draft.valueDriverItems = items;
    });
    return d;
  }, [data]);

  return (
    <div
      className="value-driver-manager manage-module-wrapper"
      id="value-driver-mask"
    >
      {isFetching ? (
        <Loading />
      ) : (
        <ValueDriverContent
          cRef={cRef}
          isSystemSetting={true}
          data={dataFormated}
          saveData={actions.saveValuedriverTemplate}
          afterSaveData={afterSave}
          goBack={afterSave}
          formExpand={formExpand}
          setFormExpand={setFormExpand}
          formChange={formChange}
        />
      )}
    </div>
  );
}

ValueDriver.propTypes = {};

export default memo(ValueDriver);
